import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  endorsementsContainer: {
    background: theme.colorPalette.green_90,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  marginBottom: {
    marginBottom: theme.spacing(2)
  },
  header: {
    borderTop: `1px solid ${theme.onCardDivider.green_75_op_40}`,
    padding: theme.spacing(2, 0),
    width: '100%'
  },
  checkboxContainer: {
    marginTop: theme.spacing(3)
  }
});

export default makeStyles(styles);
